import { render, staticRenderFns } from "./TepContratoInternoForm.vue?vue&type=template&id=645a3dba"
import script from "./TepContratoInternoForm.vue?vue&type=script&lang=js"
export * from "./TepContratoInternoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports